module.exports = __webpack_public_path__ + "static/media/screenshot-pinterest.93d795c0.jpg";